// Centralized client configuration for API and Socket URLs.
//
// In PRODUCTION the API/auth calls use same-origin RELATIVE paths ("/api", "/auth").
// Vercel rewrites (see client/vercel.json) proxy those to the Railway backend, which
// keeps the session cookie first-party on the Vercel domain. Without this the cookie
// is third-party and mobile Safari (ITP) silently drops it — bouncing users back to
// the login page after Google sign-in.
//
// In DEVELOPMENT we talk to the local backend directly.
const isProd = process.env.NODE_ENV === 'production';

// Forced relative in prod so the proxy is always used; configurable in dev.
const SERVER_BASE_URL = isProd ? '' : (process.env.REACT_APP_SERVER_BASE || 'http://localhost:5001');

export const API_BASE = `${SERVER_BASE_URL}/api`;
export const AUTH_BASE = `${SERVER_BASE_URL}/auth`;

// Socket.IO can't be proxied through Vercel rewrites, so it connects straight to the
// backend. The socket handshake doesn't depend on the session cookie (the client passes
// userId explicitly via join_user_room), so connecting cross-origin is fine here.
export const SOCKET_URL =
  process.env.REACT_APP_SOCKET_URL ||
  (isProd ? 'https://utrade-production.up.railway.app' : 'http://localhost:5001');

// Feedback form link. The env override is only trusted if it actually looks like a
// form link — it was once misconfigured to the backend URL in Vercel, which made the
// "Give Feedback" button open the API and show "Cannot GET /". A bad value now safely
// falls back to the canonical Google Form.
const DEFAULT_FEEDBACK_FORM_URL = 'https://forms.gle/R7tnWD9sMpLAitwN8';
const RAW_FEEDBACK = process.env.REACT_APP_FEEDBACK_FORM_URL || '';
const FEEDBACK_LOOKS_VALID =
  /^https:\/\//.test(RAW_FEEDBACK) &&
  /(forms\.gle|docs\.google\.com|forms\.office\.com|typeform\.com|tally\.so|airtable\.com)/.test(RAW_FEEDBACK);
export const FEEDBACK_FORM_URL = FEEDBACK_LOOKS_VALID ? RAW_FEEDBACK : DEFAULT_FEEDBACK_FORM_URL;

export default {
  SERVER_BASE_URL,
  API_BASE,
  AUTH_BASE,
  SOCKET_URL,
  FEEDBACK_FORM_URL,
};
